import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {
  Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, TableSortLabel,
  IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Divider
} from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CloseIcon from '@mui/icons-material/Close';
import { getListAPI as getPmorderList } from 'components/pmorder/PmorderAPI';
import { setPmorderList, setPmorderDashboardPmorderList } from 'store/slice/PharmaSlice';
import PmorderDashboard from '../PmorderDashboard';
import { getPmorderInfoByStatusAPI, getPmorderInfoByProductidAPI} from 'components/pmorder/PmorderAPI';
import { getListAPI } from 'components/pmorder/PmorderAPI';
import { receivePMorderAPI } from 'api/OmsOrdermgmtWebServices';
import { updatePmorderObj } from 'store/slice/PharmaSlice';

import { openDrawer } from './../../../store/slice/MenuSlice';
import NavItem from '../../../layout/MainLayout/Drawer/DrawerContent/Navigation/NavItem';

export default function PmorderPageImpl() {
    const dispatch = useDispatch();
    const { pmorderList } = useSelector((state)=>state.pharmaslice.pmorderDashboard);
    const {productObj} = useSelector((state)=>state.pharmaslice.productDashboard);
    const {taskApiResponse, taskApiResponseError} = useSelector((state) => state.appslice.wkflow);
    const [taskCompleted, setTaskCompleted] = useState(false);

    // Sorting state
    const [orderBy, setOrderBy] = useState('id');
    const [order, setOrder] = useState('asc');

    // Dialog state
    const [open, setOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [receivedQty, setReceivedQty] = useState('');
    const [receivedDate, setReceivedDate] = useState('');

    useEffect(() => {
      if (taskApiResponse && taskApiResponse.success!== undefined && taskApiResponse.success) {
        setTaskCompleted(true);
      } else {
        setTaskCompleted(false);
      }
    },[taskCompleted]);

    // Add state for error message
    const [apiError, setApiError] = useState('');

    const handleSort = (property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };

    const handleOpenDialog = (order) => {
      setSelectedOrder(order);
      setReceivedQty(order.qty);
      setReceivedDate(new Date().toISOString().slice(0, 10));
      setOpen(true);
    };

    const handleCloseDialog = () => {
      setOpen(false);
      setSelectedOrder(null);
      setReceivedQty('');
      setReceivedDate('');
    };

    // Update handleSave to set error
    const handleSave = () => {
      if (!selectedOrder) return;
      setApiError('');
      receivePMorderAPI(
        {
          pmOrderId: selectedOrder.id,
          qty: receivedQty,
          receivedOn: receivedDate
        },
        (apiResponse) => {
            dispatch(updatePmorderObj(apiResponse.pmorderInfo))
          handleCloseDialog();
          setApiError('');
          // Optionally refresh list here
        },
        (err) => {
          setApiError(err);
        }
      );
    };

    // Sorting function
    const sortedList = React.useMemo(() => {
      console.log("pmorderList=>", JSON.stringify(pmorderList));
      return pmorderList;
      // if (!pmorderList) return [];
      // return [...pmorderList].sort((a, b) => {
      //   let aValue = a[orderBy];
      //   let bValue = b[orderBy];
      //   if (typeof aValue === 'string') aValue = aValue.toLowerCase();
      //   if (typeof bValue === 'string') bValue = bValue.toLowerCase();
      //   if (aValue < bValue) return order === 'asc' ? -1 : 1;
      //   if (aValue > bValue) return order === 'asc' ? 1 : -1;
      //   return 0;
      // });
    }, [pmorderList, orderBy, order]);

    useEffect(() => {
        getPmorderInfoByProductidAPI(productObj.id, () => {}, (response) => {
            dispatch(setPmorderList(response));
            dispatch(setPmorderDashboardPmorderList(response));
        });
        // getPmorderInfoByStatusAPI("PLACED", ()=>{}, (response) => {
        //     dispatch(setPmorderList(response));
        //     dispatch(setPmorderDashboardPmorderList(response));
        // });
    },[]);

    return (
       <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: 'primary.lighter' }}>
                  <TableCell
                    sx={{ backgroundColor: 'primary.lighter', color: 'primary.main', fontWeight: 600 }}
                    sortDirection={orderBy === 'id' ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === 'id'}
                      direction={orderBy === 'id' ? order : 'asc'}
                      onClick={() => handleSort('id')}
                    >
                      Order ID
                    </TableSortLabel>
                  </TableCell>
                  {/* <TableCell
                    sx={{ backgroundColor: 'primary.lighter', color: 'primary.main', fontWeight: 600 }}
                    sortDirection={orderBy === 'productid' ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === 'productid'}
                      direction={orderBy === 'productid' ? order : 'asc'}
                      onClick={() => handleSort('productid')}
                    >
                      Product ID
                    </TableSortLabel>
                  </TableCell> */}
                  <TableCell
                    sx={{ backgroundColor: 'primary.lighter', color: 'primary.main', fontWeight: 600 }}
                    sortDirection={orderBy === 'title' ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === 'title'}
                      direction={orderBy === 'title' ? order : 'asc'}
                      onClick={() => handleSort('title')}
                    >
                      Title
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    sx={{ backgroundColor: 'primary.lighter', color: 'primary.main', fontWeight: 600 }}
                    sortDirection={orderBy === 'qty' ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === 'qty'}
                      direction={orderBy === 'qty' ? order : 'asc'}
                      onClick={() => handleSort('qty')}
                    >
                      Ordered Qty
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    sx={{ backgroundColor: 'primary.lighter', color: 'primary.main', fontWeight: 600 }}
                    sortDirection={orderBy === 'pmstatus' ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === 'pmstatus'}
                      direction={orderBy === 'pmstatus' ? order : 'asc'}
                      onClick={() => handleSort('pmstatus')}
                    >
                      Status
                    </TableSortLabel>
                  </TableCell>
                  <TableCell />
                  
                </TableRow>
              </TableHead>
              <TableBody>
                {pmorderList && pmorderList.length > 0 ? (
                  pmorderList
                    //.filter(row => row.orderedqty > 0) // Only show items where qty > 0
                    .map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          '&:hover': {
                            backgroundColor: 'primary.lighter',
                            '& td': { color: 'primary.main', fontWeight: 500 }
                          }
                        }}
                      >
                        <TableCell>{row.id}</TableCell>
                        {/* <TableCell>{row.productid}</TableCell> */}
                        <TableCell>{row.title}</TableCell>
                        <TableCell>{row.orderedqty} {row.unitname}</TableCell>
                        <TableCell>{row.pmstatus}</TableCell>
                        {!taskCompleted && (<TableCell align="right">
                          <IconButton onClick={() => handleOpenDialog(row)}>
                            <Inventory2OutlinedIcon color="primary" />
                          </IconButton>
                        </TableCell>)}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6}>
                      <Typography align="center" color="text.secondary">
                        No orders found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        {/* Receive Dialog */}
        <Dialog open={open} onClose={handleCloseDialog} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Receive Packaging Material
            </Typography>
            <IconButton aria-label="close" onClick={handleCloseDialog} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Divider />
          <DialogContent>
            {selectedOrder && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                {/* Title and Quantity Container */}
                <Box sx={{ backgroundColor: 'secondary.100', borderRadius: 1, p: 2 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Box>
                      <Typography variant="h5" sx={{ fontWeight: 500 }}>
                        Title
                      </Typography>
                      <Typography variant="body1" sx={{ color: 'text.secondary', mb: 1 }}>
                        {selectedOrder.title}
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'right' }}>
                      <Typography variant="h5" sx={{ fontWeight: 500 }}>
                        Quantity
                      </Typography>
                      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                        {selectedOrder.qty} {selectedOrder.unitname}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                {/* Received Quantity and Date Container */}
                <Box sx={{ backgroundColor: 'white', borderRadius: 1, p: 2 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', gap: 4 }}>
                    <Box sx={{ minWidth: 160 }}>
                      <Typography variant="h6" sx={{  fontWeight: 500 }}>
                        Received  Quantity({selectedOrder.unitname})
                      </Typography>
                      <TextField
                        type="number"
                        size="small"
                        value={receivedQty}
                        onChange={e => setReceivedQty(e.target.value)}
                        inputProps={{ min: 0, max: selectedOrder.qty }}
                        sx={{ mt: 0.5 }}
                        fullWidth
                      />
                    </Box>
                    <Box sx={{ minWidth: 180 }}>
                      <Typography variant="h6" sx={{  fontWeight: 500 }}>
                        Receiving Date
                      </Typography>
                      <TextField
                        type="date"
                        size="small"
                        value={receivedDate}
                        onChange={e => setReceivedDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        sx={{ mt: 0.5 }}
                        fullWidth
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            {apiError && (
              <Box sx={{ width: '100%', mb: 1 }}>
                <Typography color="error" variant="body2" align="center">
                  {apiError}
                </Typography>
              </Box>
            )}
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button variant="contained" onClick={handleSave} disabled={!receivedQty || !receivedDate}>
              Save
            </Button>
          </DialogActions>
        </Dialog>
       </Grid>
    )
}